module.exports = __webpack_public_path__ + "static/media/premiacao_04.989b4559.jpg";